<template>
  <v-container fluid>
    <v-row style="flex: 0 0 auto;">
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号" dense outlined clearable hide-details
          @keyup.enter="getdata()">
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6" v-if="queryForm.own_type == 4 || queryForm.own_type == 5">
        <v-select v-model="queryForm.vehicle_type" label="车辆属性" dense outlined clearable :items="[
          { text: '全部', value: 0 },
          { text: '自有车', value: 1 },
          { text: '临调车', value: 2 },
          { text: '包车', value: 3 },
        ]" no-data-text="无" :menu-props="{ bottom: true, offsetY: true }" hide-details @change="getdata()">
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.postlineid" :items="postlines" label="线路"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.own_type" size="small" @change="(v) => changeown_type(v)">
      <a-tab-pane :key="0" tab="全部"></a-tab-pane>
      <a-tab-pane :key="1" tab="自有车"></a-tab-pane>
      <a-tab-pane :key="3" tab="包车"></a-tab-pane>
      <a-tab-pane :key="2" tab="临调车"></a-tab-pane>
      <a-tab-pane :key="4" tab="里程汇总统计"></a-tab-pane>
      <a-tab-pane :key="5" tab="日环比分析"></a-tab-pane>
    </a-tabs>
    <v-card tile>
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="vehicleH">
          <p>车牌号</p>
          <p>车辆类型</p>
        </template>
        <template slot="vehicle" slot-scope="text, record">
          <p>{{ record.vehicle_number }}</p>
          <p>{{ record.vehicle_type }}</p>
          <p v-if="queryForm.own_type === 0" :style="{
            'color': $utils.textToBgColor(record.own_type)
          }">{{ record.own_type }}</p>
        </template>
        <template slot="gcount" slot-scope="text, record">
          {{ record.waybills.length }}
        </template>
        <template slot="lichengH">
          <p class="success--text">GPS里程</p>
          <p class="error--text">合同里程</p>
        </template>
        <template slot="licheng" slot-scope="text, record">
          <p class="success--text">{{ record.mileage }}</p>
          <p class="error--text">{{ record.km }}</p>
        </template>
        <template slot="incomeH">
          收入
        </template>
        <template slot="income" slot-scope="text, record">
          <span class="success--text">{{ record.income }}</span>
        </template>
        <template slot="profitH">
          利润
        </template>
        <template slot="profit" slot-scope="text, record">
          <span :class="{
            'success--text': record.profit > 0,
            'error--text': record.profit < 0,
          }">{{ record.profit }}</span>
        </template>
        <template slot="waybills" slot-scope="text, record">
          <!-- 全部/自有车/包车/临调车 展示嵌套子表；里程汇总/日环比 维持原 postroute 文本 -->
          <template v-if="[0, 1, 2, 3].includes(queryForm.own_type)">
            <a-table size="small" :pagination="false" :show-header="true" :columns="taskInnerColumns"
              :data-source="record.waybills" :locale="{ emptyText: '暂无任务' }" class="inner-task-table">
              <template slot="timeH">
                <p class="success--text">出发时间</p>
                <p class="error--text">到达时间</p>
              </template>
              <template slot="time" slot-scope="text, record">
                <p class="success--text">{{ record.out_time }}</p>
                <p class="error--text">{{ record.in_time || '-' }}</p>
              </template>
              <template slot="lichengH">
                <p class="success--text">GPS里程</p>
                <p class="error--text">合同里程</p>
              </template>
              <template slot="licheng" slot-scope="text, record">
                <p class="success--text">{{ record.mileage }}</p>
                <p class="error--text">{{ record.km }}</p>
              </template>
              <template slot="ocost" slot-scope="text, record">
                <p>{{ record.ocost }}</p>
                <p class="error--text" v-if="record.ocost_ > 0">{{ record.ocost_ }}</p>
              </template>
              <template slot="rcost" slot-scope="text, record">
                <p>{{ record.rcost }}</p>
                <p class="error--text" v-if="record.rcost_ > 0">{{ record.rcost_ }}</p>
              </template>
            </a-table>
          </template>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "StatisticsGps",
  data() {
    return {
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
      ],
      queryForm: {
        start_day: "",
        end_day: "",
        own_type: 1,
        vehicle_number: "",
        postlineid: null,
      },
      start_day_menu: false,
      end_day_menu: false,
      vehicle_types: [],
      own_types: [],
      postlines: [],
      headers: [],
      // 自有车"执行任务"列内嵌子表表头（antd a-table）
      // 7 列：挂箱 / 出发地 / 出发时间 / 到达时间 / 时长(h) / 目的地 / 里程(KM)
      list: [],
      height: 400,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    listheaders() {
      return [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 70, align: "center" },
        { title: "日期", dataIndex: "date", scopedSlots: { customRender: "date" }, width: 100, align: "center" },
        { dataIndex: "vehicle", slots: { title: "vehicleH" }, scopedSlots: { customRender: "vehicle" }, width: 100, align: "center" },
        ...((this.queryForm.own_type === 1 || this.queryForm.own_type === 3) ? [
          { title: "挂箱数", dataIndex: "gcount", scopedSlots: { customRender: "gcount" }, width: 80, align: "center" },
        ] : []),
        { dataIndex: "licheng", slots: { title: "lichengH" }, scopedSlots: { customRender: "licheng" }, width: 100, align: "center" },
        { dataIndex: "income", slots: { title: "incomeH" }, scopedSlots: { customRender: "income" }, width: 80, align: "center" },
        { dataIndex: "profit", slots: { title: "profitH" }, scopedSlots: { customRender: "profit" }, width: 80, align: "center" },
        { title: "执行任务", dataIndex: "waybills", scopedSlots: { customRender: "waybills" }, align: "center" },
      ];
    },
    taskInnerColumns() {
      return [
        { title: "挂箱", dataIndex: "vehicle_gnumber", width: 95, align: "center" },
        { title: "出发地", dataIndex: "departure", width: 85, align: "center" },
        { dataIndex: "time", slots: { title: "timeH" }, scopedSlots: { customRender: "time" }, width: 120, align: "center" },
        { title: "时长(h)", dataIndex: "duration", width: 70, align: "center" },
        { title: "目的地", dataIndex: "destination", width: 80, align: "center" },
        { dataIndex: "licheng", slots: { title: "lichengH" }, scopedSlots: { customRender: "licheng" }, width: 80, align: "center" },
        ...((this.queryForm.own_type === 1 || this.queryForm.own_type === 3) ? [
          { title: "车辆成本", dataIndex: "vcost", width: 80, align: "center" },
          { title: "司机成本", dataIndex: "dcost", width: 80, align: "center" },
          { title: "油费", dataIndex: "ocost", scopedSlots: { customRender: "ocost" }, width: 80, align: "center" },
          { title: "电费", dataIndex: "ecost", width: 80, align: "center" },
          { title: "过路费", dataIndex: "rcost", scopedSlots: { customRender: "rcost" }, width: 80, align: "center" },
          { title: "总成本", dataIndex: "cost", width: 80, align: "center" },
        ] : []),
      ];
    },
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.computeHeight();
    window.onresize = () => {
      this.computeHeight();
    };
    let start_day = this.$moment().subtract(1, 'day').format('YYYY-MM-DD');
    let end_day = this.$moment().subtract(1, 'day').format('YYYY-MM-DD');
    this.queryForm = {
      start_day,
      end_day,
      own_type: 1,
      vehicle_number: "",
      postlineid: null,
    };
    this.list = [];
  },
  activated() {
    this.getdata();
  },
  methods: {
    changeown_type(v) {
      console.log(v)
      if (v == 5) {

        this.queryForm.start_day = this.$moment(this.queryForm.end_day).subtract(6, 'day').format('YYYY-MM-DD');
        this.queryForm.end_day = this.$moment().subtract(1, 'day').format('YYYY-MM-DD');
      }
      // 离开「里程汇总/日环比」时重置车辆属性，避免残留值影响其他 tab 查询
      if (v != 4 && v != 5) {
        this.$set(this.queryForm, 'vehicle_type', 0);
      }
      this.queryForm.own_type = v
      this.getdata();
    },
    computeHeight() {
      // 容器总高 calc(100vh - 64px)，扣除查询栏+tabs+padding+v-card头部约 230px
      const h = window.innerHeight - 64 - 150;
      this.height = Math.max(300, h);
    },
    getdata() {
      this.$toast.loading({ message: "" });
      let own_typeget = 0
      // 结束时间
      let end_day = ''
      // 注释   开始时间
      let start_day = ''
      if (this.queryForm.own_type == 4 || this.queryForm.own_type == 5) {
        own_typeget = 0
        if (this.queryForm.own_type == 5) {
          // 日环比分析：
          //   end_day 保持用户选的值
          //   start_day = end_day 的前一天（作为环比基线）
          end_day = this.queryForm.end_day;
          start_day = this.$moment(this.queryForm.start_day).subtract(1, 'day').format('YYYY-MM-DD');
        }
        console.log(start_day)
        console.log(end_day)
      }
      else {
        own_typeget = this.queryForm.own_type
        end_day = this.queryForm.end_day;
        start_day = this.queryForm.start_day;
      }

      this.$api.doAPI("/statistics/vehiclegps2", {
        ...this.queryForm,
        own_type: own_typeget,
        start_day,
        end_day
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          // 里程汇总统计 / 日环比分析：own_type 固定传 0 查全部，
          // 车辆属性(vehicle_type)筛选后端在该模式下不生效，这里在前端按选中属性过滤
          let rawList = res.data.list || [];
          const vt = Number(this.queryForm.vehicle_type);
          if ((this.queryForm.own_type == 4 || this.queryForm.own_type == 5) && vt > 0) {
            // own_type 兼容数字(1/2/3)与中文(自有车/临调车/包车)
            const ownNameMap = { 1: '自有车', 2: '临调车', 3: '包车' };
            rawList = rawList.filter((it) => Number(it.own_type) === vt || it.own_type === ownNameMap[vt]);
          }
          this.list = rawList;
          this.vehicle_types = res.data.vehicle_types;
          this.own_types = res.data.own_types;
          this.postlines = res.data.postlines;
          if (this.queryForm.own_type == 4) {
            this.headers = [
              { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
              { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 100, align: "center" },
              { title: "车辆类型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 100, align: "center" },
              { title: "车辆属性", dataIndex: "own_type", scopedSlots: { customRender: "own_type" }, width: 110, align: "center" },
              { title: "里程(KM)", dataIndex: "mileage", scopedSlots: { customRender: "mileage" }, width: 120, align: "center" },
            ]
            // 按车牌号合并处理
            const groupMap = new Map();
            this.list.forEach(item => {
              const plate = item.vehicle_number;
              if (groupMap.has(plate)) {
                const target = groupMap.get(plate);
                // 单据数量累加
                target.count += item.count;
                // 里程字符串转数字累加，最后转回字符串保留一位小数
                target.mileage = (parseFloat(target.mileage) + parseFloat(item.mileage)).toFixed(1);
                // 运单数组合并
                target.waybills = [...target.waybills, ...item.waybills];
              }
              else {
                // 首次存入直接深拷贝防止引用污染
                groupMap.set(plate, {
                  ...item,
                  waybills: [...item.waybills]
                });
              }
            });

            // Map转数组得到最终合并结果
            const result = Array.from(groupMap.values());
            console.log(JSON.stringify(result, null, 2));
            this.list = result;

            return
          }
          if (this.queryForm.own_type == 5) {
            // 日环比分析：buildDayOnDayTable 直接修改 this.headers 和 this.list，不返回值
            this.buildDayOnDayTable(this.list, start_day, end_day);
            console.log(this.list);
            return;
          }
          this.headers = this.listheaders;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    // 生成 start_day ~ end_day 之间（含两端）每天的表头，升序排列
    getDays(start_day, end_day) {
      const days = [];
      // 起始日：用户选的 start_day；缺失则用 end_day；都没有则用今天
      const start = start_day || end_day || this.queryForm.end_day || this.$moment().format('YYYY-MM-DD');
      // 结束日：用户选的 end_day；缺失则用 start_day；都没有则用今天
      const end = end_day || start_day || this.queryForm.end_day || this.$moment().format('YYYY-MM-DD');
      // 计算天数差（含两端）作为 n
      const diff = this.$moment(end).diff(this.$moment(start), 'days');

      const n = diff >= 0 ? diff + 1 : 1;
      console.log(n);

      for (let i = 0; i < n; i++) {

        const m = this.$moment(start).add(i, 'days');
        // 提取日期 key 避免重复 format 拼接
        const dateKey = m.format('YYYY-MM-DD');
        const slotName = `day_${dateKey}`;
        const h = this.$createElement;
        days.push({
          title: m.format('YYYY-MM-DD'),
          dataIndex: slotName,
          // 用 customRender 渲染函数 + domProps.innerHTML 把 HTML 字符串解析成真实节点，
          // 避免 v-html 在 a-table slot 内被当成文本输出
          customRender: (text) => h('div', {
            class: 'day-ratio-cell',
            domProps: { innerHTML: text },
          }),
          width: 110,
          align: 'center',
        });
      }
      return days;
    },
    // 构建日环比分析表格
    buildDayOnDayTable(list, start_day, end_day) {
      // 1) 最近 7 天表头（升序：旧→新）
      const dayHeaders = this.getDays(start_day, end_day);
      const baseHeaders = [
        { title: '序号', dataIndex: 'index', scopedSlots: { customRender: 'index' }, width: 70, align: 'center' },
        { title: '车牌号', dataIndex: 'vehicle_number', scopedSlots: { customRender: 'vehicle_number' }, width: 120, align: 'center' },
        { title: '车辆类型', dataIndex: 'vehicle_type', scopedSlots: { customRender: 'vehicle_type' }, width: 100, align: 'center' },
        { title: '车辆属性', dataIndex: 'own_type', scopedSlots: { customRender: 'own_type' }, width: 110, align: 'center' },
      ];
      this.headers = [...baseHeaders, ...dayHeaders];

      // 2) 按 车牌 + 日期 聚合当天里程
      const byPlateDate = {};
      const plateInfo = {};
      (list || []).forEach((it) => {
        const plate = it.vehicle_number;
        if (!plate) return;
        if (!byPlateDate[plate]) byPlateDate[plate] = {};
        byPlateDate[plate][it.date] = (byPlateDate[plate][it.date] || 0) + (parseFloat(it.mileage) || 0);
        if (!plateInfo[plate]) {
          plateInfo[plate] = {
            vehicle_type: it.vehicle_type || '',
            own_type: it.own_type || '',
          };
        }
      });

      // 3) 为每辆车生成 7 天环比
      const rows = Object.keys(byPlateDate).map((plate) => {
        const dailyMap = byPlateDate[plate];
        const ratios = dayHeaders.map((d, idx) => {
          const dateKey = d.dataIndex.replace('day_', '');
          const cur = dailyMap[dateKey] || 0;
          if (idx === 0) {
            return { date: dateKey, ratio: null, current: cur };
          }
          const prevDate = dayHeaders[idx - 1].dataIndex.replace('day_', '');
          const prev = dailyMap[prevDate] || 0;
          let ratio = null;
          if (prev > 0) {
            // 保留一位小数
            ratio = parseFloat((((cur - prev) / prev) * 100).toFixed(1));
          }
          else if (cur > 0) {
            ratio = 100.0;
          }
          else {
            ratio = 0.0;
          }

          return { date: dateKey, ratio, current: cur, qian: prev };
        });

        const validRatios = ratios.slice(1).map((r) => r.ratio).filter((v) => v !== null && Number.isFinite(v));
        const avgRatio = validRatios.length > 0
          ? validRatios.reduce((a, b) => a + b, 0) / validRatios.length
          : 0;

        // 按表头规则把 day_YYYY-MM-DD 字段直接展开到行对象顶层（与 getDays 中 dataIndex 拼接保持一致）
        const row = {
          _id: plate,
          vehicle_number: plate,
          vehicle_type: plateInfo[plate].vehicle_type,
          own_type: plateInfo[plate].own_type,
          ratios,
          avgRatio,
        };
        dayHeaders.forEach((d, idx) => {
          console.log(d, idx);
          // 与 getDays 一致：day_${YYYY-MM-DD}，直接拼成带 % 的字符串，保留一位小数
          // 单元格内换行：第一行环比百分比，第二行 "cur - prev" 里程明细
          const r = ratios[idx].ratio;
          const cur = ratios[idx].current;
          const qian = ratios[idx].qian;
          if (r === null || r === undefined || !Number.isFinite(Number(r))) {
            row[d.dataIndex] = '-';
          }
          else {
            row[d.dataIndex] = `<div>${Number(r).toFixed(1)}%</div><div class="day-ratio-detail">${qian} - ${cur}</div>`;
          }
        });
        return row;
      });

      // 4) 按车辆属性固定顺序：自有车 → 包车 → 临调；同类内按平均环比倒序
      //    后端 own_type 可能是字符串（"自有车"/"包车"/"临调车"）或数字（1/2/3）
      const ownTypeOrder = {
        '自有车': 1, '包车': 2, '临调车': 3,
        1: 1, 3: 2, 2: 3,
      };
      rows.sort((a, b) => {
        const oa = ownTypeOrder[a.own_type] ?? ownTypeOrder[String(a.own_type)] ?? 99;
        const ob = ownTypeOrder[b.own_type] ?? ownTypeOrder[String(b.own_type)] ?? 99;
        if (oa !== ob) return oa - ob;
        return (b.avgRatio || 0) - (a.avgRatio || 0);
      });

      // 5) 把 dataIndex === start_day 的那一列从 headers 里移除（不展示开始日期列）
      const startCol = start_day;
      if (startCol) {
        this.headers = this.headers.filter((h) => h.dataIndex !== `day_${startCol}`);
      }
      this.list = rows;
    },
    // 自有车"执行任务"内嵌子表：把外层 record.waybills 转成 7 列行
    // 真实数据：waybill 通常只有 postroute（如 "商丘-安阳(商1)"），其他字段缺失
    // postroute 拆出出发地/目的地；挂箱/时间/时长/里程 缺失时显示 '--'
    getTaskRows(record) {
      const placeholder = '--';
      const waybills = (record && record.waybills) || [];
      return waybills.map((w, i) => {
        // postroute 形如 "商丘-安阳(商1)" / "商丘→安阳(商1)"
        const route = w.postroute || '';
        let startplace = placeholder;
        let endplace = route || placeholder;
        if (route) {
          // 按 "→/-/—/～" 拆出起止
          const parts = route.split(/[→\-—～]/);
          if (parts.length >= 2) {
            startplace = parts[0].trim() || placeholder;
            endplace = parts[1].trim() || route;
          }
          else {
            // 单地址：作为目的地，出发地置 --
            endplace = route;
          }
        }
        return {
          _id: w._id || `${record._id || record.vehicle_number || 'row'}_${i}`,
          hangbox: w.hangbox || w.hang_box || placeholder,
          startplace,
          starttime: w.starttime || w.start_time || placeholder,
          endtime: w.endtime || w.end_time || placeholder,
          duration: w.duration ?? placeholder,
          endplace,
          mileage_t: w.mileage != null && w.mileage !== ''
            ? Number(w.mileage).toFixed(1)
            : placeholder,
        };
      });
    },
    // 格式化环比百分比
    formatRatio(r) {
      if (r === null || r === undefined) return '-';
      const v = Number(r);
      if (!Number.isFinite(v)) return '-';
      return `${v > 0 ? '+' : ''}${v.toFixed(1)}%`;
    },
    // 环比 class
    ratioClass(r) {
      if (r === null || r === undefined) return '';
      const v = Number(r);
      if (!Number.isFinite(v)) return '';
      if (v > 0) return 'ratio-up';
      if (v < 0) return 'ratio-down';
      return 'ratio-flat';
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-header>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-tabs-bar {
  margin: 0 0 4px 0;
}

p {
  margin: 0;
}

/* 自有车"执行任务"列内嵌子表：紧贴外层单元格，去掉多余 padding */
.inner-task-table {
  margin: 0;
}

.inner-task-table /deep/ .ant-table {
  margin: 0;
}

.inner-task-table /deep/ .ant-table-thead>tr>th,
.inner-task-table /deep/ .ant-table-tbody>tr>td {
  font-size: 11px;
}

.inner-task-table /deep/ .ant-table-thead>tr>th {
  background: #e6f0ff;
  font-weight: 600;
  text-align: center;
}

.inner-task-table /deep/ .ant-table-tbody>tr>td {
  text-align: center;
}

/* 日环比单元格：两行布局（百分比 + 里程明细） */
.day-ratio-cell {
  text-align: center;
  line-height: 1.3;
}

.day-ratio-cell .day-ratio-detail {
  margin-top: 2px;
  font-size: 11px;
  color: #888;
}
</style>